import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, message, Col, Row, Select } from 'antd';
import axiosInstance from '../../utils/axios';


const SeatTypeModal = ({ open, setOpen, seatTypes, setSeatTypes, selectedId}) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [selectedItem, setSelectedItem] = useState(null);

	useEffect(() => {
		if (open) {
			if (selectedId !== null) {
				const item = seatTypes.find(p => p.id === selectedId);
				setSelectedItem(item);

				if (item) {
					form.setFieldsValue({ 
            name: item.name, 
            seat_model: item.seat_model, 
            price: item.price
          });
				}

			} else {
				setSelectedItem(null);
				form.resetFields();
			}
		}
	}, [open, selectedId, seatTypes]);

	const handleCancel = () => {
    setOpen(false);
    form.resetFields();
    setSelectedItem(null);
  };

	const handleFinish = async (values) => {
    setLoading(true);

    try {
      let response;
      if (selectedItem) {
        response = await axiosInstance.patch(`core/seat-type/${selectedItem.id}/`, values);
        setSeatTypes(prev => prev.map(p => (p.id === selectedItem.id ? response.data : p)));
        message.success("Item updated successfully!");

      } else {
        response = await axiosInstance.post(`core/seat-type/`, values);
        setSeatTypes(prev => [...prev, response.data]);
        message.success("Item added successfully!");
      }

      form.resetFields();
      setOpen(false);
    } catch (error) {
      if(error.response && error.response.data &&  error.response.data)
        message.error(error.response.data.name[0]);
      else
        message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

	return (
		<Modal
			title={selectedItem ? "Edit Seat Type" : "Add Seat Type"}
      open={open}
      onCancel={handleCancel}
      destroyOnClose
      okButtonProps={{
        autoFocus: true,
        htmlType: 'submit',
        loading: loading,
        disabled: loading,
      }}
      onOk={() => form.submit()}
		>
 			<Form
        layout="vertical"
        form={form}
        name="language_form"
        onFinish={handleFinish}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Seat Type"
              name="name"
              rules={[{ required: true, message: 'Please enter a seatTypes' }]}
            >
              <Input placeholder="Eg: Recliner" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Seat Model"
              name="seat_model"
              rules={[{ required: true, message: 'Please select one' }]}
              initialValue="single"
            >
              <Select>
                <Select.Option value='single'>Single</Select.Option>
                <Select.Option value='double'>Double</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Price"
              name="price"
              help="Only for special price"
            >
              <Input type="number" min={0}/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
		</Modal>
	)
}

export default SeatTypeModal